/**
 * Dedupe keys for the trigger calls area-ms and visit-ms make against stork-api.
 *
 * The key is the business identity of the trigger, mirroring how stork-api resolves the affected
 * step: a customer trigger is matched by (trip, location, type) and an area trigger by
 * (trip, zone, type). Two calls sharing a key therefore resolve to the same step, which is exactly
 * what must not be applied twice.
 *
 * Deliberately not keyed by checkpoint index or position: indexes move when checkpoints are
 * reordered, and the duplicates being suppressed come from different positions of the same vehicle.
 */

export const buildCustomerTriggerDedupeKey = (tripId: string, locationId: string, type: string): string =>
    `trigger:customer:${tripId}:${locationId}:${type}`;

export const buildAreaTriggerDedupeKey = (tripId: string, zoneId: string, type: string): string =>
    `trigger:area:${tripId}:${zoneId}:${type}`;
